import { Table, Pagination, Spin, Row, Col } from 'antd';

export default function PaginatedTable({
    dataSource,
    total,
    defaultPageSize = 20,
    columns,
    isFetching,
    OnChangePaginator,
    Footer,
    pageNum,
    pageSize,
    ...props
}) {
    const spinIcon = (
        <div className="spin-center">
            <Spin className="spin_loader" size="large" />{' '}
        </div>
    );

    const OnChangePage = (pageNum, pageSize) => {
        OnChangePaginator(pageNum, pageSize);
    };

    return (
        <>
            <div
                style={{
                    height: props.height || 'calc(100vh - 120px)',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <div
                    style={{
                        flexGrow: 1,
                        overflow: 'auto',
                    }}
                >
                    <Table
                        rowKey={props.rowKey}
                        columns={columns}
                        dataSource={dataSource}
                        loading={{
                            spinning: isFetching,
                            indicator: spinIcon,
                        }}
                        pagination={props.pagination ?? false}
                        bordered
                        size="small"
                        rowClassName={props.rowClassName}
                        className={`common-table ${props.customClass ?? ''}`}
                        {...props}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Pagination
                        pageSizeOptions={props.pageSizeOptions || [20, 50]}
                        total={total}
                        defaultPageSize={defaultPageSize || 20}
                        defaultCurrent={1}
                        showSizeChanger={true}
                        showTitle={true}
                        onChange={OnChangePaginator}
                        style={{
                            borderTop: '1px solid #888888',
                            padding: '2px',
                            marginBottom: '3px',
                            maxHeight: props?.paginationMaxHeight ?? 'inherit',
                        }}
                        showTotal={(total, range) => {
                            return (
                                <>
                                    <div>Total : {total} items</div>
                                </>
                            );
                        }}
                        pageSize={pageSize}
                        current={pageNum}
                    />
                    {Footer}
                </div>
            </div>
        </>
    );
}
